export class ReportUtil{

    // check if object empty
  public static isEmptyObject(obj){
    return JSON.stringify(obj) === '{}';
  }
}